<template>
  <div>
    <data-table-card
      :items="items"
      v-on:updateData="getProducts"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:header-buttons v-if="userHasPerms(['Manage products'])">
        <b-button
          class="ml-2"
          :to="{ name: 'products-create' }"
          variant="primary"
        >
          <i class="lni lni-circle-plus m-0"></i>
        </b-button>
      </template>

      <template v-slot:cards="slotProps">
        <router-link
          :to="{
            name: 'products-show',
            params: { id: slotProps.item.id },
          }"
          class="text-body pointer text-decoration-none"
        >
          <div class="row no-gutters">
            <div class="col-4 col-xl-3 p-1">
              <v-lazy-image
                v-if="slotProps.item.image"
                :src="slotProps.item.image"
                class="img-fluid"
              />

              <div
                v-if="slotProps.item.is_active == 1"
                class="
                  mt-1
                  py-1
                  text-white
                  font-weight-bold
                  text-center
                  bg-success
                  font-size-11
                "
              >
                Active
              </div>
              <div
                v-if="slotProps.item.is_active == 0"
                class="
                  mt-1
                  py-1
                  text-white
                  font-weight-bold
                  text-center
                  bg-danger
                  font-size-11
                "
              >
                Obsolete
              </div>
              <div
                v-if="slotProps.item.is_active == 2"
                class="
                  mt-1
                  py-1
                  text-white
                  font-weight-bold
                  text-center
                  bg-warning
                  font-size-11
                "
              >
                On Hold
              </div>
            </div>
            <div class="col-8 col-xl-7 p-3">
              <h5 class="font-weight-bold">
                {{ slotProps.item.name }}
                
              </h5>
              <strong>{{ slotProps.item.code }} </strong> 
              <small class="font-normal text-primary" v-if="slotProps.item.average_mass">[{{ slotProps.item.average_mass }} kg]</small>
              <br>
              <span class="text-black-50"
                >{{ slotProps.item.product_group.name }}</span
              >
              <br />


               {{ slotProps.item.brand.name }}
              <span
                v-if="slotProps.item.brand.name != slotProps.item.supplier.name"
              >
                <br />
               <i class="lni lni-user font-size-11"></i> {{ slotProps.item.supplier.name }}
              </span>

              <h5 class="font-weight-bold mt-2 mb-0">
                {{ slotProps.item.mandate_pricing_min | currency }}
                
              </h5>
            </div>
          </div>
        </router-link>

      </template>
    </data-table-card>

    <b-modal
      :hide-footer="true"
      :title="$route.meta.title"
      size="lg"
      v-model="sidebarToggle"
      :no-close-on-route-change="true"
      @hidden="$router.push({ name: 'products' })"
      :lazy="true"
    >
      <router-view
        @productCreated="productCreated()"
        @productUpdated="productUpdated()"
      ></router-view>
    </b-modal>
  </div>
</template>

<script>
import productRepo from "@/api/repos/productRepo";
import dataTableCard from "@/components/common/DataTableCard";

export default {
  components: {
    dataTableCard: dataTableCard,
  },

  data() {
    return {
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "name", label: "Name Asc", order: "asc" },
      sortOptions: [
        { column: "name", label: "Name Asc", order: "asc" },
        { column: "name", label: "Name Desc", order: "desc" },
        { column: "created_at", label: "Date Created Asc", order: "asc" },
        { column: "created_at", label: "Date Created Desc", order: "desc" },
        { column: "code", label: "Code Asc", order: "asc" },
        { column: "code", label: "Code Desc", order: "desc" },
        {
          column: "mandate_pricing_min",
          label: "Mandate Price Asc",
          order: "asc",
        },
        {
          column: "mandate_pricing_min",
          label: "Mandate Price Desc",
          order: "desc",
        },
      ],
      filterOptions: [],
      filterStr:null,
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getProducts({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      search: "",
    });
  },
  methods: {
    async getFilterData() {
      let { data } = await productRepo.createGetData();

      this.filterOptions.push({
        column: "group-heading",
        label: "groups",
      });

      data.product_groups.forEach((p) => {
        this.filterOptions.push({
          column: "product_group_id",
          value: p.id,
          label: p.name,
        });
      });

      this.filterOptions.push({
        column: "group-heading",
        label: "suppliers",
      });

      data.suppliers.forEach((s) => {
        this.filterOptions.push({
          column: "supplier_id",
          value: s.id,
          label: s.name,
        });
      });

      this.filterOptions.push({
        column: "group-heading",
        label: "brands",
      });

      data.brands.forEach((b) => {
        this.filterOptions.push({
          column: "brand_id",
          value: b.id,
          label: b.name,
        });
      });
    },

    async getProducts(e) {
      this.isLoad = true;
      try {

        if(e.filters != null){
            this.filterStr = e.filters
        }else{
            this.filterStr = null
        }

        let { data } = await productRepo.products(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          this.filterStr,
        );

        this.items = data.products.data;
        this.totalRows = data.products.total;
        this.page = data.products.current_page;
        this.fromRow = data.products.from;
        this.toRow = data.products.to;
        this.lastPage = data.products.last_page;


        this.filterOptions = [];

        this.filterOptions.push({
          column: "is_active",
          value: "1",
          label: "Active",
        });

        this.filterOptions.push({
          column: "is_active",
          value: "0",
          label: "Obsolete",
        });

        this.filterOptions.push({
          column: "is_active",
          value: "2",
          label: "On Hold",
        });

        this.getFilterData();
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

    productCreated() {
      this.$bvToast.toast("Product Created", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sort = {
        column: "created_at",
        label: "Date Created Desc",
        order: "desc",
      };
      this.page = 1;
      this.sidebarToggle = false;
      this.getProducts({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 12,
        search: "",
      });
    },

    productUpdated() {
      this.$bvToast.toast("Product Updated", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sidebarToggle = false;
      this.getProducts({
        sort: this.sort,
        filters:this.filterStr,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 12,
        search: "",
      });
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
